import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initAnalytics } from './lib/analytics'
import { reloadForChunkError } from './lib/chunkReload'
import { Capacitor } from '@capacitor/core'

// After a new deploy, an already-open session can request an old (now-missing)
// lazy chunk. Vite fires this event when a module preload fails — reload once
// to fetch the fresh version instead of leaving the user on a broken tab.
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault()
  reloadForChunkError()
})

if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  navigator.serviceWorker.register('/sw.js').then(reg => {
    // Check for updates when user returns to the tab.
    // Listener is stored so it can be removed if the registration is replaced.
    // .catch swallows iOS Safari's "newestWorker is null" rejection, which was
    // surfacing as a captured $exception on every tab-focus update check.
    const onVisibility = () => { if (document.visibilityState === 'visible') reg.update().catch(() => {}) }
    document.addEventListener('visibilitychange', onVisibility)
  }).catch(() => {})
}

initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
